// client/src/components/auth/AuthShell.js
import React from 'react';

// Casca visual compartilhada por Login/ForgotPassword — identidade SituAI
// (gradiente da marca + logo), já que essas telas rodam antes de qualquer
// Conta ser identificada (sem cor de tenant pra herdar).
const AuthShell = ({ children, tagline }) => (
    <div className="auth-shell">
        <div className="auth-shell-blob auth-shell-blob-1" />
        <div className="auth-shell-blob auth-shell-blob-2" />

        <div className="auth-shell-content">
            <div className="auth-shell-brand">
                <img src="/images/brand/logo-mark-white.png" alt="SituAI" className="auth-shell-logo" />
                <h1 className="auth-shell-wordmark">SituAI</h1>
                {tagline && <p className="auth-shell-tagline">{tagline}</p>}
            </div>

            <div className="auth-shell-card">
                {children}
            </div>

            <p className="auth-shell-terms">
                Ao continuar, você confirma que aceita nossos{' '}
                <a href="https://situai.com.br/institucional" target="_blank" rel="noreferrer">Termos de Uso</a>
            </p>
        </div>
    </div>
);

export default AuthShell;
